var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63086 6.20117C2.62956 5.79492 3.58594 5.5918 4.5 5.5918C5.41406 5.5918 6.36198 5.79492 7.34375 6.20117C8.34245 6.59049 8.8418 7.10677 8.8418 7.75V8.8418H0.158203V7.75C0.158203 7.10677 0.649089 6.59049 1.63086 6.20117ZM6.02344 3.86523C5.60026 4.28841 5.09245 4.5 4.5 4.5C3.90755 4.5 3.39974 4.28841 2.97656 3.86523C2.55339 3.44206 2.3418 2.93424 2.3418 2.3418C2.3418 1.74935 2.55339 1.24154 2.97656 0.818359C3.39974 0.378255 3.90755 0.158203 4.5 0.158203C5.09245 0.158203 5.60026 0.378255 6.02344 0.818359C6.44661 1.24154 6.6582 1.74935 6.6582 2.3418C6.6582 2.93424 6.44661 3.44206 6.02344 3.86523Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d07f0268f55876c12b4d6cc82c2dca18.svg";
export { ForwardRef as ReactComponent };